import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { TrendingUpIcon } from 'lucide-react';
export function Proof() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-navy py-16 md:py-20 px-6" data-id="element-92">
      <div className="max-w-4xl mx-auto" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-gold/10 to-cyan/10 p-10 md:p-12 rounded-xl border-2 border-gold/30" data-id="element-94">
          <div className="flex items-center gap-3 mb-6" data-id="element-95">
            <TrendingUpIcon className="w-8 h-8 text-cyan" data-id="element-96" />
            <h2 className="text-3xl md:text-4xl font-oswald text-gold" data-id="element-97">
              Resultados Comprobados
            </h2>
          </div>

          <p className="text-xl text-gray-300 leading-relaxed mb-6" data-id="element-98">
            En los primeros <span className="text-gold font-bold" data-id="element-99">7 días</span>,
            notarás que la defensiva de tu hijo baja. Al dejar de atacar a sus
            amigos y empezar a evaluar conductas, la comunicación se abre.
          </p>

          <p className="text-lg text-gray-400 leading-relaxed" data-id="element-100">
            Este no es un libro de teoría, es un{' '}
            <span className="text-cyan font-semibold" data-id="element-101">
              manual de campo probado
            </span>{' '}
            en hogares biculturales que enfrentan exactamente tus mismos miedos.
          </p>
        </motion.div>
      </div>
    </section>;
}